/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerSearchRequestModel } from '../../models/practitioner-search-request-model';
import { PractitionerSearchResponseModel } from '../../models/practitioner-search-response-model';

export interface PractitionerFindrPractitionersPost$Params {
      body?: PractitionerSearchRequestModel
}

export function practitionerFindrPractitionersPost(http: HttpClient, rootUrl: string, params?: PractitionerFindrPractitionersPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<PractitionerSearchResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, practitionerFindrPractitionersPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<PractitionerSearchResponseModel>>;
    })
  );
}

practitionerFindrPractitionersPost.PATH = '/PractitionerFindr/Practitioners';
